/** Agent/human view keys used by the Katie agent control plane. */
export type ViewKey = 'dashboard' | 'data' | 'review' | 'settings';

export const VIEW_ROUTES: Record<ViewKey, string> = {
  dashboard: '/dashboard',
  data: '/upload',
  review: '/approvals',
  settings: '/profile',
};
